import React, { useEffect, useState } from 'react';
import SvgIcon from '@mui/material/SvgIcon';
import Container from '@mui/material/Container';
import Button from '@mui/material/Button';
import AppTheme from '../templates/shared-theme/AppTheme';
import Box from '@mui/material/Box';
import { alpha, styled } from '@mui/material/styles';

const StyledBox = styled(Box)(({ theme }) => ({
	display: 'flex',
	alignItems: 'center',
	justifyContent: 'space-between',
	flexDirection: 'column',
	flexShrink: 0,
	borderRadius: `calc(${theme.shape.borderRadius}px + 8px)`,
	backdropFilter: 'blur(24px)',
	border: '1px solid',
	// borderColor: (theme.vars || theme).palette.divider,
	borderColor: 'rgb(101, 220, 244)',
	backgroundColor: theme.vars
			? `rgba(${theme.vars.palette.background.defaultChannel} / 0.4)`
			: alpha(theme.palette.background.default, 0.4),
	boxShadow: (theme.vars || theme).shadows[1],
	padding: '8px 24px',
	marginBottom: 36,
}));

const AuthKeyHandler = () => {
	const [message, setMessage] = useState('');
	const [errorCode, setErrorCode] = useState(null);

	useEffect(() => {
		const urlParams = new URLSearchParams(window.location.search);
		const authKey = urlParams.get('auth_key');
		const errorCode = urlParams.get('error_code');
		const scope = urlParams.get('scope');
		const success = urlParams.get('success');
		const state = JSON.parse(urlParams.get('state') || '{}');

		if ( success === 'true' ) {
			setMessage(`This auth key has been successfully stored.  You can now close this page. `);
			return;
		}

		if (errorCode) {
			setErrorCode(errorCode);
			setMessage(`Error encountered. Please send this error code to the administrator: ${errorCode}`);
			return;
		}

		if (authKey) {
			if ( !scope || scope.indexOf('write_invest_order') < 0 ) {
				setErrorCode('MISSING_WRITE');
				setMessage(`Error encountered. Write access was not granted. This can happen if 'Write & Read Access' was not selected on the previous page.`);
				return;
			}


			const recordTimestamp = new Date(state.storeTimestamp);
			const now = new Date();
			const oldestAllowableTime = new Date(now.getTime() - 15 * 60 * 1000);
			const isOld = recordTimestamp < oldestAllowableTime;
			console.log('isOld', isOld, recordTimestamp, oldestAllowableTime);
			// Process took longer than 15 minutes and timed out. Please complete the process again.

			fetch('https://nr4gpozfngwqavodtmdxpqgjg40xvizn.lambda-url.us-east-1.on.aws/', {
				method: 'POST',
				headers: {
					'Content-Type': 'application/json',
				},
				body: JSON.stringify({ auth_key: authKey, id: state.storeId }),
			})
			.then((response) => {
				if (!response.ok) {
					throw new Error('Failed to complete authorization.');
				}
				return response.json();
			})
			.then(() => {
				setMessage('Authorization completed successfully. The transactions will begin executing automatically when funds are cleared. You can now close this page.  ');

				const url = new URL(window.location.href);
				url.searchParams.set('success', 'true');
				window.history.replaceState(null, '', url.toString());
			})
			.catch((error) => {
				setErrorCode('ERROR_STORING_KEY');
				setMessage(`Error: ${error.message}`);

				const url = new URL(window.location.href);
				url.searchParams.set('state', '{}}');
				window.history.replaceState(null, '', url.toString());
			});
		} else {
			setErrorCode('MISSING_KEY');
			setMessage('Authorization key not found in the URL.');
		}
	}, []);

	return (

			<AppTheme>
				<Box
						id="hero"
						sx={(theme) => ({
							width: '100%',
							backgroundRepeat: 'no-repeat',
							backgroundImage:
									'radial-gradient(ellipse 80% 50% at 50% -20%, hsl(210, 100%, 90%), transparent)',
							...theme.applyStyles('dark', {
								backgroundImage:
										'radial-gradient(ellipse 80% 50% at 50% -20%, hsl(210, 100%, 16%), transparent)',
							}),
						})}
				>

					<div style={{ fontFamily: 'Arial, sans-serif', textAlign: 'center' }}>
						<Container>
							<div style={{width: '100%', display: 'flex', position: 'relative', marginBottom: 52, paddingTop: 24,}}>
								<SvgIcon sx={{}}>
									<svg style={{height: 200, width: 218, margin: '0 auto'}} version="1.0" xmlns="http://www.w3.org/2000/svg" width={500} height={500} viewBox="130 210 240 90" preserveAspectRatio="xMidYMid meet">
										<g fill="#0adff7">
											<path d="M179.10 337.45 l0.15 -4.60 2.35 -0.05 c1.40 0 2.50 0.20 2.60 0.55 0.35 0.80 -0.20 1.15 -1.80 1.15 -1.05 0 -1.40 0.25 -1.40 1 0 0.80 0.35 1 1.50 1 1 0 1.50 0.25 1.50 0.75 0 0.50 -0.50 0.75 -1.50 0.75 -1.25 0 -1.50 0.20 -1.50 1.25 0 1.10 0.20 1.25 1.80 1.25 2.90 0 1.80 1.20 -1.25 1.40 l-2.60 0.15 0.15 -4.60z"/>
											<path d="M192.50 337.35 c0 -4.40 0.05 -4.65 1.05 -4.65 0.75 0 1.60 0.80 2.75 2.65 0.95 1.40 1.70 2.90 1.70 3.25 0 0.45 0.15 0.45 0.50 -0.10 0.30 -0.40 0.45 -1.65 0.40 -2.75 -0.05 -1.15 0.10 -2.30 0.30 -2.65 0.90 -1.50 1.30 -0.25 1.30 4.20 l0 4.75 -1.35 -0.15 c-1.05 -0.10 -1.70 -0.80 -3.10 -3.40 l-1.80 -3.25 -0.15 3.40 c-0.10 2.55 -0.30 3.35 -0.85 3.35 -0.60 0 -0.75 -0.90 -0.75 -4.65z"/>
											<path d="M210.50 338.25 c0 -3.70 0 -3.75 -1.30 -3.75 -0.95 0 -1.25 -0.20 -1.10 -0.85 0.25 -1.30 6.55 -1.25 6.80 0 0.15 0.60 -0.20 0.85 -1.10 0.85 -1.30 0 -1.30 0.05 -1.30 3.75 0 3.40 -0.10 3.75 -1 3.75 -0.90 0 -1 -0.35 -1 -3.75z"/>
											<path d="M222.50 337.55 l0 -4.55 2.75 0 c2.20 0 2.65 0.15 2.45 0.75 -0.20 0.45 -0.95 0.75 -1.75 0.75 -1.10 0 -1.45 0.25 -1.45 1 0 0.80 0.35 1 1.50 1 1 0 1.50 0.25 1.50 0.75 0 0.50 -0.50 0.75 -1.50 0.75 -1.25 0 -1.50 0.20 -1.50 1.25 0 1.10 0.20 1.25 1.80 1.25 2.85 0 1.80 1.20 -1.20 1.40 l-2.60 0.15 0 -4.50z"/>
											<path d="M236 337.25 c0 -5.15 -0.15 -4.95 3.15 -4.40 1.20 0.20 2.20 0.70 2.70 1.45 0.65 1.05 0.65 1.30 -0.15 2.65 -0.90 1.50 -0.90 1.55 0.20 3 1.35 1.85 1.35 2.05 0.10 2.05 -0.65 0 -1.40 -0.65 -2.05 -1.75 -0.60 -0.95 -1.25 -1.75 -1.50 -1.75 -0.25 0 -0.45 0.80 -0.45 1.75 0 1.40 -0.20 1.75 -1 1.75 -0.95 0 -1 -0.35 -1 -4.75z m3.90 -1.65 c0.15 -0.85 -0.10 -1.10 -0.85 -1.10 -0.80 0 -1.05 0.30 -1.05 1.30 0 1.65 1.65 1.50 1.90 -0.20z"/>
											<path d="M250.50 337.30 l0 -4.75 2.40 0.30 c2.75 0.30 3.75 1.05 3.75 2.90 0 1.60 -0.95 2.65 -2.65 2.90 -0.90 0.15 -1.30 0.60 -1.50 1.65 -0.15 0.85 -0.60 1.50 -1.15 1.60 -0.75 0.15 -0.85 -0.35 -0.85 -4.60z m3.90 -1.70 c0.15 -0.85 -0.10 -1.10 -0.85 -1.10 -0.80 0 -1.05 0.30 -1.05 1.30 0 1.65 1.65 1.50 1.90 -0.20z"/>
											<path d="M264.60 337.40 l0.15 -4.65 2.10 0.10 c1.10 0.05 2.50 0.30 3.10 0.60 1.25 0.70 1.40 2.65 0.25 3.80 -0.75 0.70 -0.70 0.95 0.50 2.75 l1.30 2 -1.15 0 c-0.75 0 -1.40 -0.55 -2.05 -1.75 -0.55 -0.95 -1.25 -1.75 -1.65 -1.75 -0.40 0 -0.65 0.60 -0.65 1.75 0 1.45 -0.20 1.75 -1 1.75 -1 0 -1.05 -0.25 -0.90 -4.60z m3.85 -0.85 c0.95 -0.60 0.30 -2.05 -0.95 -2.05 -0.65 0 -1 0.35 -1 0.90 0 1.55 0.70 1.95 1.95 1.15z"/>
											<path d="M279.50 337.55 c0 -3.35 0.15 -4.50 0.70 -4.70 1.15 -0.45 1.30 0.10 1.30 4.75 0 4.05 -0.10 4.40 -1 4.40 -0.95 0 -1 -0.35 -1 -4.45z"/>
											<path d="M289.35 341.65 c-0.20 -0.15 -0.35 -0.60 -0.35 -1 0 -0.50 0.50 -0.60 2 -0.35 1.65 0.25 2 0.20 2 -0.50 0 -0.45 -0.75 -1.30 -1.70 -1.85 -1.85 -1.10 -2.35 -2.15 -1.75 -3.80 0.45 -1.30 2.95 -1.95 4.40 -1.15 1.55 0.80 1.25 1.50 -0.65 1.50 -2.50 0 -2.60 0.80 -0.30 2.25 1.60 1 2 1.55 2 2.75 0 0.95 -0.35 1.65 -0.95 2 -1.10 0.55 -4.20 0.70 -4.70 0.15z"/>
											<path d="M303.10 337.40 l0.15 -4.65 2.25 0.10 c1.25 0.05 2.40 0.10 2.60 0.10 0.20 0.05 0.25 0.40 0.10 0.80 -0.20 0.45 -0.95 0.75 -1.75 0.75 -1.10 0 -1.45 0.25 -1.45 1 0 0.80 0.35 1 1.50 1 1 0 1.50 0.25 1.50 0.75 0 0.50 -0.50 0.75 -1.50 0.75 -1.25 0 -1.50 0.20 -1.50 1.25 0 1.10 0.20 1.25 1.80 1.25 2.90 0 1.80 1.20 -1.25 1.40 l-2.60 0.15 0.15 -4.65z"/>
											<path d="M315.85 341.65 c-0.95 -0.90 -0.25 -1.60 1.45 -1.50 2.45 0.15 2.65 -0.80 0.55 -2.10 -3.70 -2.30 -2.15 -6.10 2.15 -5.25 0.80 0.20 1.50 0.65 1.50 1 0 0.70 -0.50 0.85 -2.35 0.75 -1.90 -0.15 -1.75 0.90 0.35 2.20 1.60 1 2 1.55 2 2.75 0 0.95 -0.35 1.65 -0.95 2 -1.10 0.55 -4.20 0.70 -4.70 0.15z"/>
											<path d="M226.75 264.50 c-0.20 -0.55 -2.65 -5.80 -5.45 -11.65 -2.85 -5.80 -5.95 -12.30 -6.95 -14.35 -5.75 -12.15 -7 -14.85 -9.75 -20.50 -1.65 -3.45 -4.50 -9.40 -6.35 -13.25 -1.85 -3.85 -4.45 -9.25 -5.75 -12 -1.30 -2.75 -4 -8.30 -5.95 -12.40 -1.95 -4.05 -3.55 -7.60 -3.55 -7.85 0 -0.30 6.40 -0.50 17.25 -0.50 9.50 0 17.25 -0.05 17.25 -0.15 0 -0.10 -0.75 -1.70 -1.70 -3.65 -1.85 -3.80 -5.45 -11.25 -5.70 -11.80 -0.10 -0.25 16 -0.40 35.80 -0.40 l36 0 -1.35 2.65 c-0.75 1.45 -3 6.10 -5 10.30 -2 4.15 -5.25 11 -7.25 15.20 -3.75 7.70 -6.90 14.35 -10.30 21.60 -1.05 2.20 -3.95 8.30 -6.50 13.50 -2.55 5.25 -4.80 10.05 -5.10 10.75 -0.45 1.15 -0.65 0.95 -2.65 -3.25 -1.15 -2.45 -3.35 -7.10 -4.90 -10.25 -1.50 -3.15 -4 -8.45 -5.55 -11.75 -1.55 -3.30 -4 -8.40 -5.45 -11.35 l-2.60 -5.40 -2.75 -0.05 c-2.50 0 -14.05 0 -14.40 0.05 -0.10 0 0.20 0.60 0.60 1.40 0.40 0.75 1.85 3.70 3.20 6.60 3.85 8.10 7.10 14.95 11.60 24.25 4.80 9.90 9.85 20.45 12.30 25.65 l1.70 3.60 8.65 0 8.65 0 3.05 -6.35 c1.70 -3.55 4.30 -9 5.80 -12.15 1.50 -3.15 4.15 -8.65 5.85 -12.25 1.70 -3.55 4.20 -8.75 5.50 -11.50 1.30 -2.75 3.95 -8.25 5.90 -12.25 4.20 -8.80 7.70 -16.10 10.85 -22.75 1.30 -2.75 3.60 -7.55 5.10 -10.65 l2.70 -5.60 8.70 0 c5.50 0 8.75 0.20 8.75 0.50 0 0.25 -2.15 4.90 -4.75 10.30 -2.60 5.35 -4.75 9.85 -4.75 9.95 0 0.05 -2.35 4.95 -5.20 10.80 -5.70 11.75 -8.85 18.35 -12.80 26.70 -3.45 7.25 -6.20 13 -11.85 24.70 -2.55 5.35 -4.65 9.90 -4.65 10.10 0 0.25 -4.05 0.45 -9 0.45 -4.95 0 -9 0.15 -9 0.30 0 0.30 1.20 2.25 5.10 8.10 0.75 1.20 1.40 2.25 1.40 2.35 0 0.10 0.70 1.20 1.50 2.40 0.80 1.25 1.50 2.40 1.50 2.55 0 0.15 -8.40 0.30 -18.70 0.30 -18.30 0 -18.75 0 -19.05 -1z"/>
										</g>
										<g fill="#ffffff">
											<path d="M144 302.50 l0 -10.50 -3.55 0 -3.50 0 0.15 -2.10 0.15 -2.15 9.65 -0.15 9.60 -0.10 0 2.25 0 2.25 -3.50 0 -3.50 0 0 10.50 0 10.50 -2.75 0 -2.75 0 0 -10.50z"/>
											<path d="M171 300.25 l0 -12.75 5.05 0 c8.40 0 11.30 1.30 12.45 5.55 0.80 2.90 0 5.40 -2.30 7.45 -1 0.85 -1.70 1.80 -1.55 2.15 0.15 0.35 1.75 2.75 3.55 5.35 l3.25 4.75 -2.55 0.15 c-1.40 0.10 -2.80 0.05 -3.15 -0.05 -0.30 -0.15 -1.80 -2.30 -3.30 -4.80 -2.50 -4.20 -2.80 -4.50 -4.30 -4.55 l-1.65 0 0 4.75 0 4.75 -2.75 0 -2.75 0 0 -12.75z m11.05 -2.30 c0.45 -0.25 1 -1 1.15 -1.70 0.65 -2.55 -1.40 -4.25 -5 -4.25 l-1.70 0 0 3.15 c0 1.75 0.15 3.35 0.35 3.50 0.35 0.40 4.05 -0.10 5.20 -0.70z"/>
											<path d="M205.50 300.25 l0 -12.75 2.75 0 2.75 0 0 12.75 0 12.75 -2.75 0 -2.75 0 0 -12.75z"/>
											<path d="M228 300.25 l0 -12.75 5.30 0 c2.95 0 6.20 0.25 7.25 0.55 4.85 1.45 6.75 7.50 3.90 12.20 -1.30 2.20 -3.50 3.25 -7.45 3.60 l-3.50 0.30 0 4.40 0 4.45 -2.75 0 -2.75 0 0 -12.75z m10.20 -1.30 c1.65 -0.75 2.50 -2.85 1.85 -4.60 -0.65 -1.65 -1.95 -2.35 -4.50 -2.35 l-2.05 0 0 3.75 0 3.75 1.75 0 c0.95 0 2.25 -0.25 2.95 -0.55z"/>
											<path d="M261.50 300.25 l0 -12.75 2.75 0 2.75 0 0 10.50 0 10.50 5.15 0 5.15 0 -0.05 2.15 -0.05 2.10 -7.85 0.15 -7.85 0.15 0 -12.80z"/>
											<path d="M292.50 300.25 l0 -12.75 7.25 0 7.25 0 0 2.25 0 2.25 -4.50 0 -4.50 0 0 2.75 0 2.75 4.25 0 4.25 0 0 2.25 0 2.25 -4.25 0 -4.25 0 0 3.25 0 3.25 4.50 0 4.50 0 0 2.25 0 2.25 -7.25 0 -7.25 0 0 -12.75z"/>
											<path d="M348.75 312.45 c-0.40 -0.60 -8.25 -24 -8.25 -24.55 0 -0.25 1.20 -0.40 2.65 -0.40 l2.65 0 2.60 8.40 c1.40 4.60 2.75 9.10 3 10.05 l0.40 1.75 0.85 -3.25 c0.50 -1.75 1.85 -6.25 3.05 -9.95 l2.15 -6.75 2.85 -0.15 c2.25 -0.10 2.85 0 2.65 0.50 -0.15 0.35 -2.10 6.10 -4.35 12.80 l-4.10 12.10 -2.90 0 c-1.60 0 -3.10 -0.25 -3.25 -0.55z"/>
										</g>
									</svg>
								</SvgIcon>
							</div>
							<StyledBox>
								<h1>Authorization Status</h1>
								{
									!message ? (
											<p>Loading...</p>
									) : null
								}
								{errorCode ? (
										<div style={{ color: 'red' }}>
											<p>{message}</p>
										</div>
								) : (
										<p>{message}</p>
								)}
							</StyledBox>
						</Container>
					</div>
				</Box>
			</AppTheme>
	);
};

export default AuthKeyHandler;
